const setSearchParams = (obj, facet) => {
  const [key, value] = facet.queryStringId.split('=');

  const decodedValue = decodeURIComponent(value);
  let existingValue;

  if(obj[key]) {
    existingValue = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
  }

  const newValue = existingValue ? [...existingValue, decodedValue] : decodedValue;

  return {
    ...obj,
    [key]: newValue,
  };
};

export const createSearchParams = ({facets, sort, frequency}) => {
  const searchParam = facets.reduce((parameters, facet) => {
    const [key] = facet.queryStringId.split('=');

    // this is necessary because the qs for coordinates will come back as
    // "displayLocation=City&point=x,y", unlike every other facet that has individual query strings,
    // so we need to separate them.
    if (key === 'displayLocation') {
      // displayFacet: displayLocation=City
      // pointFacet: point=x,y
      const params = decodeURIComponent(facet.queryStringId).split('&');
      return params.reduce((acc, param) => {
        return setSearchParams(acc, {queryStringId: param});
      }, parameters);
    }

    // this is the only facet that can only be sent through
    // as a string not as an array
    if (key === 'applicationType') {
      return {
        ...parameters,
        applicationType: facet.queryAs,
      };
    }

    return setSearchParams(parameters, facet);
  }, { sort }); 

  searchParam.frequency = frequency;

  return searchParam;
};